
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NoneAddedPopup from '../NoneAddedPopup';
import { generateRuleSet } from '../../../../../reducers/JsonRuleEditor/RulesActions';

export default function Generate() {
    const dispatch = useDispatch();
    const currentRule = useSelector(state => state.JsonRulesEditorReducer.currentRule);
    const generatedRuleSet = useSelector(state => state.JsonRulesEditorReducer.generatedRuleSet);
    const [showJson, setShowJson] = useState(false);

    const handleGenerate = () => {
        dispatch(generateRuleSet());
        setShowJson(true);
    };

    const handleDownload = () => {
        if (!generatedRuleSet) return;
        
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(generatedRuleSet, null, 2));
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", `${currentRule.ruleName}.json`);
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    };

    return (
        <>
            <NoneAddedPopup 
                heading={"Submit Ruleset"} 
                text={"You have created / modified this ruleset. Do you want to save these changes into ruleset file?"} 
                buttonText={"Generate Ruleset"} 
                buttonFn={handleGenerate} 
                borderColor={"green"} 
            />
            
            {showJson && generatedRuleSet && (
                <div className="mt-4">
                    <div className="card">
                        <div className="card-header" style={{display:'flex', justifyContent:'space-between',alignItems:'center',color:'#fff',background:'#198754',borderTopLeftRadius:'6px',borderTopRightRadius:'6px',padding:'8px 16px'}}>
                            <h5 className="" style={{fontSize:'20px',margin:'0'}}>Generated Rule JSON</h5>
                            <button 
                                className="addbtn" 
                                onClick={handleDownload}
                            >
                                <i className="fa fa-download"></i> Download JSON
                            </button>
                        </div>
                        <div className="card-body" style={{borderTopLeftRadius:'0px',borderTopRightRadius:'0px'}}>
                            <pre style={{ background: '#f8f9fa', padding: '15px', borderRadius: '5px' }}>
                                {JSON.stringify(generatedRuleSet, null, 2)}
                            </pre>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}